const deliveryFilterCache: any = {};

export function isActiveFilter(filter: any) {
  if (!filter) {
    return false;
  }
  if (typeof filter.operator === 'string' && filter.operator === 'All') {
    return false;
  }
  return true;
}
interface BasicFilter {
  $schema: 'http://powerbi.com/product/schema#basic';
  target: {
    table: string;
    column: string;
  };
  filterType: number;
  operator: 'In' | 'NotIn';
  values: string[];
}
interface AdvancedFilter {
  $schema: 'http://powerbi.com/product/schema#advanced';
  target: {
    table: string;
    column: string;
  };
  filterType: number;
  logicalOperator: 'And' | 'Or';
  conditions: {
    operator: 'Contains' | 'DoesNotContain' | 'StartsWith' | 'DoesNotStartWith' | 'Is' | 'IsNot' | 'IsBlank' | 'IsNotBlank';
    value?: string;
  }[];
}


// From array [1, 2, 3] returns string "1, 2 and 3"
function joinWithEnd(array: number[] | string[], final: string = 'and'): string {
  let result = '';
  for (let i = 0; i < array.length; i++) {
    if (i !== 0) {
      if (i + 1 === array.length) {
        result += ' ' + final + ' ';
      } else {
        result += ', ';
      }
    }
    result += array[i].toString();
  }
  return result;
}

function joinWithAnd(array: number[] | string[]) {
  return joinWithEnd(array, 'and');
}

function joinWithOr(array: number[] | string[]) {
  return joinWithEnd(array, 'or');
}

// camelCaseStyle => camel case style
function camelCaseToSpaceSeparated(str) {
  return str.replace(/[A-Z]/g, l => ` ${l.toLocaleLowerCase()}`);
}

function isBasicFilter(filter: any): filter is BasicFilter {
  if (!filter || typeof filter !== 'object' || typeof filter.$schema !== 'string' || typeof filter.operator !== 'string') {
    return false;
  }
  if (filter.operator !== 'In' && filter.operator !== 'NotIn') {
    throw new Error('Unexpected operator ' + filter.operator);
  }
  return filter.$schema.endsWith('#basic');
}

function isAdvancedFilter(filter: any): filter is AdvancedFilter {
  if (!filter || typeof filter !== 'object' || typeof filter.$schema !== 'string') {
    return false;
  }
  return filter.$schema.endsWith('#advanced');
}

export function extractFilterFromDeliveryJSONArray(filterStr: string): string[] {
  if (!filterStr || filterStr === '{}' || filterStr === '[]') {
    return [];
  }
  if (deliveryFilterCache[filterStr] instanceof Array) {
    return deliveryFilterCache[filterStr];
  }

  const filters = JSON.parse(filterStr);
  const activeFilters = filters.filter(isActiveFilter);
  const filterStrings: string[] = activeFilters.map(filter => {
    if (isBasicFilter(filter)) {
      const target = ((filter.target.table.includes(' ') ? '\'' + filter.target.table + '\'' : filter.target.table) +
        '[' + filter.target.column + ']');
      return (target + ' is ' +
        camelCaseToSpaceSeparated(filter.operator) + ' ' +
        (filter.values.length > 2 ?
          filter.values.length + ' values' :
          joinWithOr(filter.values.map(value => '"' + value + '"'))));
    } else if (isAdvancedFilter(filter)) {
      const target = ((filter.target.table.includes(' ') ? '\'' + filter.target.table + '\'' : filter.target.table) +
        '[' + filter.target.column + ']');
      return (target + ' ' +
        filter.conditions.map(condition => camelCaseToSpaceSeparated(condition.operator) +
          (condition.value ? ' "' + condition.value + '"' : '')).join(filter.logicalOperator.toLowerCase()));
    } else {
      console.warn('Got unhandled schema', filter);
      return 'unknown filter';
    }
  });
  deliveryFilterCache[filterStr] = filterStrings;
  return filterStrings;
}

export function extractFilterFromDeliveryJSON(filterStr: string): string {
  return joinWithAnd(extractFilterFromDeliveryJSONArray(filterStr));
}
